const getters = {
  // sex: state => state.app.sex.map(item => item.label),
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  basicInfo: state => state.app.basicInfo,

  drawer: state => state.app.drawer,
  theme: state => state.app.theme,
  themeColor: state => state.app.themeColor,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  showSubApp: state => state.permission.showSubApp,
  // isShow404: state => state.permission.isShow404,
  subApp: state => state.permission.subApp,
  // status: state => state.user.status,
  roles: state => state.user.roles,
  userInfo: state => state.user.userInfo,
  userType: state => state.user.userType,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  menuList: state => state.user.menuList,
  customMenuList: state => state.user.customMenuList
  // constant: state => state.constant.constant,
  // courseCart: state => state.apply.courseCart,
  // printCard: state => state.apply.printCardInfo,
  // campusStatus: state => state.campus.campusStatus,
  // exportStatus: state => state.exportFile.exportStatus,
  // itemQuestionMsg: state => state.itemQuestionMsg.msg
};
export default getters;
